"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalDevelop = exports.isUAT = exports.isKflowUAT = exports.isMiniUat = exports.isMiniDomain = exports.isOukuUat = exports.isAdorUat = exports.isLitbUat = exports.isLitbOukuDomain = exports.isAdorDomain = exports.isLTDomain = void 0;
var url_1 = require("utils/url");
var ssrcontext_1 = require("../ssrcontext");
var LITB_DOMAIN = [
    /(?:lightinthebox.com|miniinthebox.com|mqa\d?.tbox.me)/
];
var LITB_ADOR_DOMAIN = ["ador.com"];
var LITB_OUKU_DOMAIN = ["ouku.com", "oukku.com"];
exports.isLTDomain = function () {
    var hostname = ssrcontext_1.runInServer() ? ssrcontext_1.getSnapshootByKey("hostname") : location.hostname;
    return LITB_DOMAIN.some(function (domain) {
        return hostname.match(domain);
    });
};
exports.isAdorDomain = function () {
    var hostname = ssrcontext_1.runInServer() ? ssrcontext_1.getSnapshootByKey("hostname") : location.hostname;
    return LITB_ADOR_DOMAIN.some(function (domain) { return hostname.indexOf(domain) > -1; });
};
exports.isLitbOukuDomain = function () {
    var hostname = ssrcontext_1.runInServer() ? ssrcontext_1.getSnapshootByKey("hostname") : location.hostname;
    return LITB_OUKU_DOMAIN.some(function (domain) { return hostname.indexOf(domain) > -1; });
};
exports.isLitbUat = function () {
    return exports.isLTDomain() && url_1.getSearchParamValue("litbuat");
};
exports.isAdorUat = function () {
    return exports.isAdorDomain() && url_1.getSearchParamValue("litbuat");
};
exports.isOukuUat = function () {
    return exports.isLitbOukuDomain() && url_1.getSearchParamValue("litbuat");
};
exports.isMiniDomain = function () {
    var hostname = ssrcontext_1.runInServer() ? ssrcontext_1.getSnapshootByKey("hostname") : location.hostname;
    return hostname.indexOf("miniinthebox.com") > -1;
};
exports.isMiniUat = function () {
    return exports.isMiniDomain() && url_1.getSearchParamValue("litbuat");
};
exports.isKflowUAT = function () {
    return exports.isUAT() && "-api." + url_1.getSearchParamValue("kflow");
};
exports.isUAT = function () {
    var hostname = (ssrcontext_1.runInServer()
        ? { hostname: ssrcontext_1.getSnapshootByKey("hostname") }
        : window.location).hostname;
    return (hostname.indexOf("192.168") > -1 ||
        hostname.indexOf("localhost") > -1 ||
        hostname.indexOf("127.0") > -1 ||
        hostname.indexOf("ezbuy.dev") > -1 ||
        hostname.indexOf("65emall.net") > -1 ||
        hostname.indexOf("ezbuy.me") > -1 ||
        !!exports.isLitbUat() ||
        !!exports.isAdorUat() ||
        !!exports.isOukuUat());
};
exports.isLocalDevelop = function () {
    var hostname = (ssrcontext_1.runInServer()
        ? { hostname: ssrcontext_1.getSnapshootByKey("hostname") }
        : window.location).hostname;
    return (hostname.indexOf("192.168") > -1 ||
        hostname.indexOf("localhost") > -1 ||
        hostname.indexOf("127.0") > -1 ||
        hostname.indexOf("ezbuy.asia") > -1);
};
